import ResyRewardsAppHome from './ResyRewardsAppHome';

export default ResyRewardsAppHome;
